import { Box, Grid, Stack } from '@mui/material';
import constants from '../../../utils/constants';
import { bottom } from '@popperjs/core';

function VideosGallery({ videos }) {
  const videoList = videos?.map(video => {
    const embedId = video.video_id.replace('https://vimeo.com/', '');

    return {
      embedId,
      embedUrl: `${video.type === 'VIMEO' ? constants.VIMEO_PLAYER_URL : constants.YOUTUBE_PLAYER_URL}/${embedId}`,
      videoType: video.type,
    }
  });

  if (!videoList.length) return null;

  return (
      <Stack
        sx={{
          my: 3,
          width: "100%",
        }}
      >
        <Grid container
          spacing={2}
        >
          {
            videoList.map(item => (
              <Grid item
                xs={12}
                key={item.embedId}
              >
                <Box
                  className=""
                  sx={{
                    position: "relative",
                    height: 0,
                    width: "100%",
                    pb: "56.25%",
                    background: "#222",
                    alignContent: "center"
                  }}
                >
                  <iframe
                    src={item.embedUrl}
                    className="video-list_img"
                    title="Recipe Video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      height: "100%",
                      width: "100%",
                    }}
                  />
                </Box>
              </Grid>
            ))
          }
        </Grid>
      </Stack>
  )
}

export default VideosGallery